var r, e;
function t() {
  return e || (e = 1, r = Function.call.bind(Object.prototype.hasOwnProperty)), r;
}
export {
  t as __require
};
//# sourceMappingURL=index.es526.js.map
